const manager = require('./dist/manager');

manager.init();
